import React from 'react';
import { Box, Container, Typography, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function TermsOfUse() {

  return (
    <Box sx={{ bgcolor: '#ffffff', minHeight: '100vh', py: 6 }}>
      <Container maxWidth="md">
        {/* Header */}
        <Typography variant="h3" sx={{ fontWeight: 700, mb: 2, color: '#111827' }}>
          Terms of Use
        </Typography>
        <Typography variant="body2" sx={{ color: '#6b7280', mb: 4 }}>
          Last Updated: October 2025
        </Typography>

        <Divider sx={{ mb: 4 }} />

        {/* Introduction */}
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          Welcome to Sniffr.ai. By accessing or using this website, you agree to comply with and be bound 
          by the following terms and conditions. Please read them carefully before using our website or services.
        </Typography>

        {/* Acceptance of Terms */}
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: '#1f2937' }}>
          1. Acceptance of Terms
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          By using Sniffr.ai's website, requesting a demo, or engaging with our content, you acknowledge 
          that you have read, understood, and agree to be bound by these Terms of Use and our Privacy Policy.
        </Typography>

        {/* Use of the Website */}
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: '#1f2937' }}>
          2. Use of the Website
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 2, lineHeight: 1.8 }}>
          You agree to use this website only for lawful purposes and in a way that does not infringe the 
          rights of others or restrict their use and enjoyment.
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          All content, materials, and design elements on this site are owned by Sniffr.ai and QDEX Consulting 
          and are protected by applicable copyright and intellectual property laws.
        </Typography>

        {/* Intellectual Property */}
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: '#1f2937' }}>
          3. Intellectual Property
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          The Sniffr.ai name, logo, and all related materials are trademarks or service marks of QDEX Consulting. 
          You may not reproduce, distribute, or modify any materials on this website without prior written permission.
        </Typography>

        {/* Limitation of Liability */}
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: '#1f2937' }}>
          4. Limitation of Liability
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          While we make every effort to ensure the accuracy and reliability of the content provided, Sniffr.ai 
          and QDEX Consulting are not responsible for any direct or indirect damages arising from the use or 
          inability to use this website or its content.
        </Typography>

        {/* External Links */}
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: '#1f2937' }}>
          5. External Links
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          Our website may contain links to third-party websites. Sniffr.ai and QDEX Consulting are not 
          responsible for the content or privacy practices of any external sites.
        </Typography>

        {/* Updates to These Terms */}
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: '#1f2937' }}>
          6. Updates to These Terms
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          We may update these Terms of Use periodically. Continued use of the website after any changes 
          indicates your acceptance of the revised terms.
        </Typography>

        {/* Contact */}
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: '#1f2937' }}>
          7. Contact Us
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 2, lineHeight: 1.8 }}>
          For any questions regarding these Terms of Use, please contact us at:
        </Typography>
        <Typography variant="body1" sx={{ color: '#374151', mb: 4, lineHeight: 1.8 }}>
          <strong>Email:</strong> support@sniffr.ai<br />
          <strong>Website:</strong> https://sniffr.ai
        </Typography>

        <Divider sx={{ my: 4 }} />

        <Typography variant="body2" sx={{ color: '#6b7280', textAlign: 'center' }}>
          © 2025 Sniffr.ai. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}

